const getNumFromPx = (px) => {
	/**
	 * Turn CSS value into number
	 *
	 * @param {String} px - e.g. "1200px"
	 * @return {Number} e.g. 1200
	 */
	return parseInt(px.replace("px", ""));
};

export default getNumFromPx;
